<!-- =========================================================================================
  File Name: Coupons.vue
  Description: Data List - List View for coupans
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    <!-- <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" /> -->

    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="products">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
         <!-- <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

               <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Another Action</span>
                </span>
              </vs-dropdown-item> 

            </vs-dropdown-menu>
          </vs-dropdown>-->

          <!-- ADD NEW -->
          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary nh-invt-btns nh-custom-btn" @click="invivtationUserDialog = true">
              <feather-icon icon="MailIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Send User Invitation</span>
          </div>
          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary nh-invt-btns nh-custom-btn" @click="invivtationStaffDialog = true">
              <feather-icon icon="MailIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Send Staff Invitation</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ products.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="email">Email</vs-th>
        <vs-th sort-key="phone">Phone</vs-th>
        <vs-th sort-key="couponID">Coupon</vs-th>
        <vs-th sort-key="isredeemed">Redeemed</vs-th>		    
        <!-- <vs-th>Action</vs-th> -->
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td>
                <p class="font-medium truncate">{{ tr.email }}</p>
              </vs-td>

              <vs-td>
                <p>{{ tr.phone | title }}</p>
              </vs-td>

              <vs-td>
                <vs-chip class="nh-vs-chips" :color="'dark'" v-if="tr.userType == 2">Staff User</vs-chip>

                <p v-else>{{ tr.couponCode }}</p>
              </vs-td>

              <vs-td>
                <vs-chip class="nh-vs-chips" :color="getStatusColor(tr.isredeemed)" v-if="tr.isredeemed == 1">Reedemed</vs-chip>
                <vs-chip class="nh-vs-chips" :color="getStatusColor(tr.isredeemed)" v-else>Not Yet</vs-chip>

              </vs-td>


             <!-- <vs-td class="whitespace-no-wrap">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" />
              </vs-td>-->

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
      <!-- dialog box for sending user invitation  --> 
      <vs-prompt
        color="warning"
        class="centerx"
        title="Send User Invitation"
        acceptText="Send"
        @accept="sendUserInvitation"
         :active.sync="invivtationUserDialog" vs-w="12">
         <form>
          <div class="con-exemple-prompt vx-row">
            <div class="vx-col w-full centerx labelx">
              <vs-input type="email" name="email" v-validate="'required|email'"label="Email" v-model="inv_email"/>
              <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
            </div>
            
            <div class="vx-col w-full centerx labelx">
                <vs-input label="Phone" name="phone" v-validate="'required|numeric|min:10|max:10'" v-model="inv_phone"/>
                <span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
            </div>
    
            <div class="vx-col w-full centerx labelx mt-4">
                <!-- <vs-select class="select-coupan" name="coupon" v-validate="'required'" label="Coupon" v-model="inv_coupon">
                  <vs-select-item :key="index" :value="coupans.id" :text="coupans.couponCode" v-for="coupans,index in couponList" />
                </vs-select> -->

                <label for="" class="vs-input--label">Coupon</label>
                <v-select v-validate="'required'" class="mt-1 w-full pl-3 pr-3" name="coupon" v-model="inv_coupon" :options="couponList" />


                <span class="text-danger text-sm" v-show="errors.has('coupon')">{{ errors.first('coupon') }}</span>

            </div>
          </div>
         </form>
       </vs-prompt>

      <!-- dialog box for sending staff invitation  -->
      <vs-prompt
        color="warning"
        class="centerx"
        title="Send Staff Invitation"
        acceptText="Send"
        @accept="sendStaffInvitation"
         :active.sync="invivtationStaffDialog" vs-w="12">
          <div class="con-exemple-prompt vx-row">
            <div class="vx-col w-full centerx labelx">
              <vs-input type="email" name="sf_email" v-validate="'required|email'"label="Email" v-model="sf_email"/>
              <span class="text-danger text-sm" v-show="errors.has('sf_email')">{{ errors.first('sf_email') }}</span>
            </div>
            
            <div class="vx-col w-full centerx labelx">
              <vs-input label="Phone" name="sf_phone" v-validate="'required|numeric|min:10|max:10'" v-model="sf_phone"/>
              <span class="text-danger text-sm" v-show="errors.has('sf_phone')">{{ errors.first('sf_phone') }}</span>
            </div>
          </div>
       </vs-prompt>
  </div>
</template>

<script>
//import DataViewSidebar from '@/views/nursing-home-admin/coupons/CouponSidebar.vue'
import moduleInvitations from '@/store/data-list/invitations/moduleInvitations.js'
import { Validator } from 'vee-validate'
import vSelect from 'vue-select'

const dict = {
  custom: {
    email: {
      required: 'Field is required',
      email: 'Invalid email'
    },
    phone: {
      required: 'Field is required',
      numeric: 'Invalid phone',
      min: 'Invalid phone',
      max: 'Invalid phone'
    },
    coupon: {
      required: 'Field is required'
    },
	
    sf_email: {
      required: 'Field is required',
      email: 'Invalid email'
    },
    sf_phone: {
      required: 'Field is required',
      numeric: 'Invalid phone',
      min: 'Invalid phone',
      max: 'Invalid phone'
    }

  }
}

// register custom messages
Validator.localize('en', dict)
export default {
  data () {
    return {
      // selected: [],
      products: [],
      itemsPerPage: 4,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      invivtationUserDialog: false,
      invivtationStaffDialog: false,
      couponList: [],
      inv_email: '',
      inv_phone: '',
      inv_coupon: '',
      sf_email: '',
      sf_phone: ''
    }
  },
  components: {
   		 'v-select': vSelect
 	 },	  
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
  
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
    }
  },
  methods: {
    getCouponCode (cID) {
      //console.log(cID)
      for (let i = 0; i < this.couponList.length; i++) {
        if (this.couponList[i].id == cID) { return this.couponList[i].label }
      }
      return cID 
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteData (id) {
      this.$store.dispatch('dataList/removeItem', id).catch(err => { console.error(err) })
    },
    editData (data) {
	  // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getStatusColor (status) {
      if (status === 1)   return 'success'
      if (status === 0) return 'danger'
      return 'primary'
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    sendUserInvitation () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.invivtationUserDialog = true
          this.$vs.loading()
          const formData = new FormData()
          formData.append('couponCodeID', this.inv_coupon.id)
          formData.append('toEmail', this.inv_email)
          formData.append('phone', this.inv_phone)
          formData.append('userType', 3)
          this.$http.post('nh/nh-coupons-invitation/', formData, { headers: {'Content-Type': 'multipart/form-data' }})
            .then((response) => {
              this.$vs.loading.close()
              if (response.data.messageType == 'success') {
                this.invivtationUserDialog = false
                this.inv_coupon = ''
                this.inv_email = ''
                this.inv_phone = ''
                this.$vs.notify({title:'Great!', text:response.data.message, color:'success', position:'top-right', icon:'check_box', time:5000})
                return this.fecthInvites()
              } else {
                this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
                return this.fecthInvites()
              }
            })
            .catch((error)   => {
              this.$vs.loading.close()
              console.log(error)
              this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
              return this.fecthInvites()
            })
        } else {
          this.invivtationUserDialog = true
          // form have errors
        }
      })
    },
    sendStaffInvitation () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.invivtationStaffDialog = true
          this.$vs.loading()
          const formData = new FormData()
          formData.append('couponCodeID', 0)
          formData.append('toEmail', this.sf_email)
          formData.append('phone', this.sf_phone)
          formData.append('userType', 2)
          this.$http.post('nh/nh-coupons-invitation/', formData, { headers: {'Content-Type': 'multipart/form-data' }})
            .then((response) => {
              this.$vs.loading.close()
              if (response.data.messageType == 'success') {
                this.invivtationStaffDialog = false
                this.sf_email = ''
                this.sf_phone = ''
                this.$vs.notify({title:'Great!', text:response.data.message, color:'success', position:'top-right', icon:'check_box', time:5000})
                return this.fecthInvites()
              } else {
                this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
                return this.fecthInvites()
              }
            })
            .catch((error)   => {
              this.$vs.loading.close()
              console.log(error)
              this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
              return this.fecthInvites()
            })
        } else {
          this.invivtationStaffDialog = true
          // form have errors
        }
      })
    },
    fecthInvites () {
      this.$vs.loading()
      
      this.$http.get('nh/nh-coupons/')
        .then((response) => { 
          const all_coupans = response.data.data
          for (let i = 0; i < all_coupans.length; i++) {
            if (all_coupans[i].isActive == 1) {
              this.couponList[i] = {'id': all_coupans[i].id, 'label': all_coupans[i].couponCode}
            }
          }
          return this.couponList
        })
        .catch((error)   => {
          console.log(error)
          return this.couponList
        })

      if (!moduleInvitations.isRegistered) {
        this.$store.registerModule('invList', moduleInvitations)
        moduleInvitations.isRegistered = true
      }
      this.$store.dispatch('invList/fetchDataListItems').then((resp) => {
        this.products = resp.data.data
        this.$vs.loading.close()
      })

    }

  },
  created () {
    this.fecthInvites()
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.con-exemple-prompt {  padding: 10px; padding-bottom: 0px;}
.vs-input { width: 100%; margin-top: 10px; padding:0 10px; float: left;}
.con-select {
    width: 100%;
    clear: both;
    padding: 0px 10px;
}
</style>
